import React, { FC } from 'react';
import { Alert as AntdAlert } from 'antd';
import { AlertProps } from 'antd/lib/alert';

export const Alert: FC<AlertProps> = (props) => {
  return <AntdAlert {...props} />;
};
export default Alert;
